"use strict";
import galleryImage from "./product_gallery";

$(function () {
    galleryImage(scrollAmount => ({scrollLeft: scrollAmount}));
});
